import uuid from 'uuid';

import { NOT_RENDERED_COMPONENT_APIS } from '@philips-emr/hpms-components';
import { Placement, ToastLevel, ToastType } from '@philips-emr/tws-constants';
import { MessageService, ToastService as TS } from '@philips-emr/tws-core/lib/services';
import { HttpError, HttpStatus, RequestResponse } from '@philips-emr/tws-core/lib/services/http-service';

interface Toast {
  message: string;
  level: ToastLevel;
}

class ToastService {

  private static toasHistory: [string?] = [];

  static open(arg: RequestResponse | Toast | HttpError): void {

    const id = `tws-toast-service-${uuid()}`;
    let message;
    let level;

    if (this.isRequestResponseSuccess(arg)) {
      message = arg.body || this.getGeneralError();

      if (typeof message === 'object') {
        message = Object.values(message).shift() as string;
      }

      switch (arg.status) {
        case HttpStatus.OK:
        case HttpStatus.CREATED:
          level = ToastLevel.SUCCESS;
          break;
        case HttpStatus.BAD_REQUEST:
        case HttpStatus.UNAUTHORIZED:
        case 500:
        case 404:
          level = ToastLevel.ERROR;
          message = this.getGeneralError();
          break;
        default:
          level = ToastLevel.CAUTION;
      }
    } else if (this.isRequestResponseError(arg)) {
      level = ToastLevel.ERROR;

      if (arg.response) {
        switch (arg.response.status) {
          case HttpStatus.BAD_REQUEST:
          case HttpStatus.UNAUTHORIZED:
          case 500:
          case 404:
            message = this.getGeneralError();
            break;
          default:
            message = arg.message;
        }
      } else {
        message = this.getGeneralError();
      }
    } else {
      message = arg.message;
      level = arg.level;
    }

    if (NOT_RENDERED_COMPONENT_APIS.includes(message)) return;

    TS.open({
      id,
      dismissible: true,
      placement: Placement.TOP,
      type: ToastType.BUBBLE,
      showIcon: true,
      highlight: false,
      message,
      title: 'beneficiary.aviso',
      timeout: 7500,
      level,
    });

    if (this.toasHistory.length > 1) {
      TS.close(this.toasHistory.shift() ?? '');
    }

    this.toasHistory.push(id);
  }

  private static isRequestResponseSuccess(object: any): object is RequestResponse {
    return Object.prototype.hasOwnProperty.call(object, 'body');
  }

  private static isRequestResponseError(object: any): object is HttpError {
    return Object.prototype.hasOwnProperty.call(object, 'response');
  }

  private static getGeneralError(): string {
    return MessageService.translate('beneficiary.general-error');
  }
}

export {
  ToastService,
};
